import React, { useState, useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import categoryUserSitePublisherAction from "../../../store/actions/categoryUserSitePublisher";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import helpersTime from "../../../helpers/time";
import helpersNumbers from "../../../helpers/numbers";
import typeActionCategoryUserSitePublisher from "../../../store/actions/typeActionCategoryUserSitePublisher";
import moment from "moment";
import TitleBar from "../../partials/content/TitleBar";
import ExportFileExcelButton from "./ExportFileExcelButton";
import PreviewPositionsGroupSitePublisher from "./PreviewPositionsGroupSitePublisher";

function AllPositionsPageSitePublisher({
  startDate,
  endDate,
  dataSitePublisher,
  addPositionTagToState,
  position_added_in_edit_action,
  addedPositionInEditAction,
  typeAction,
  render,
}) {
  const params = useParams();
  const pageID = parseInt(params.id);
  const [positions, setPositions] = useState([]);
  const [pageData, setPageData] = useState();
  const [sitePublisherData, setSitePublisherData] = useState();
  const history = useHistory();
  useEffect(() => {
    const initDataComponent = async () => {
      await getPageInSitePublisher();
      await getPositionsPageSitePublisher();
      scrollForSeeMessage();
    };
    initDataComponent();
  }, []);

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".content-wrapper");
    element.scrollIntoView();
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getPageInSitePublisher = async () => {
    const pageData = await sendRequestGetPageInSitePublisher(pageID);
    setPageData(pageData);
    setSitePublisherData(
      await sendRequestGetSitePublisherData(pageData.web_site_publisher_id)
    );
  };

  const sendRequestGetPageInSitePublisher = async (pageID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return positionsPageSitePublisher.data.data;
  };

  const getPositionsPageSitePublisher = async () => {
    const positionsPageSitePublisher =
      await sendRequestGetPositionsPageSitePublisher(pageID);
    if (!positionsPageSitePublisher) {
      return;
    }

    setPositions(positionsPageSitePublisher);
  };

  const sendRequestGetPositionsPageSitePublisher = async (pageID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/position/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return positionsPageSitePublisher.data.data;
  };

  const sendRequestGetSitePublisherData = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return positionsPageSitePublisher.data.data;
  };

  const hasPositionEmptyCampaignBanner = (position) => {
    const newPendingCampaigns =
      getCampaignBannerThatOverrideCampaignDateWithDateGroup(position);
    if (position.count > newPendingCampaigns.length) {
      return true;
    }

    return false;
  };

  const getCampaignBannerThatOverrideCampaignDateWithDateGroup = (position) => {
    const startDateGroup = helpersTime.convertJalaliToGregorian(startDate);
    const endDateGroup = helpersTime.convertJalaliToGregorian(endDate);

    let newCampaigns = [];
    let activeCampaigns = position.active;
    for (const key in activeCampaigns) {
      const pendingActive = activeCampaigns[key];
      const startDateCampaign = pendingActive.start_date;
      const endDateCampaign = pendingActive.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(pendingActive);
      }
    }

    let pendingCampaigns = position.pending;
    for (const key in pendingCampaigns) {
      const pendingCampaign = pendingCampaigns[key];
      const startDateCampaign = pendingCampaign.start_date;
      const endDateCampaign = pendingCampaign.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(pendingCampaign);
      }
    }
    return newCampaigns;
  };

  const generateCheckBoxAddPositionTag = (
    position,
    isChecked,
    addPositionToState
  ) => {
    // if (
    //   isChecked === "checked" &&
    //   typeAction === typeActionCategoryUserSitePublisher.EDIT &&
    //   !position_added_in_edit_action.includes(position.tag_html_id)
    // ) {
    //   return;
    // }

    return (
      <label className="adl-switch">
        <input
          type="checkbox"
          defaultChecked={isChecked}
          onChange={(e) => {
            addPositionToState(position);
          }}
        />
        <span className="adl-slider round"></span>
      </label>
    );
  };

  const generatePositionsPageSitePublisher = () => {
    return (
      <>
        <div className="col-12 pt-2">
          <div className="alert alert-warning ">
            <p className="text-justify">
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p className="text-justify">
                  در تصویر زیر میتوانید جایگاه های تبلیغاتی هایلات را در صفحه
                  مدنظر مشاهده نمایید.
                </p>
              </li>
              <li>
                <p className="text-justify">
                  جایگاه های قرمز به معنای رزور شدن توسط کمپین کاربران است.
                </p>
              </li>
              <li>
                <p className="text-justify">
                  جهت مشاهده یکپارچه گروه نمایش دهنده خود از دکمه سبز رنگ پایین
                  سمت چپ استفاده کنید.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="px-2">
          <span>مبلغ این صفحه =</span>
          <span className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(getPricePage())
            )}
          </span>
          <span className="pr-2">تومان</span>
        </div>
        <div className="container-fluid">
          <div className="row">
            {positions.map((position, index) => {
              const isPositionEmptyCampaignBanner =
                hasPositionEmptyCampaignBanner(position);

              let isChecked = "";

              if (
                dataSitePublisher[pageData.web_site_publisher_id] !== undefined
              ) {
                if (
                  dataSitePublisher[pageData.web_site_publisher_id][pageID] !==
                  undefined
                ) {
                  const positionsTagHtmlIDS = dataSitePublisher[
                    pageData.web_site_publisher_id
                  ][pageID].positions.map((position) => position.tagHtmlID);
                  if (positionsTagHtmlIDS.includes(position.tag_html_id)) {
                    isChecked = "checked";
                  }
                }
              }

              let classBgPosition = "";
              if (isPositionEmptyCampaignBanner) {
                if (isChecked === "checked") {
                  classBgPosition = "bg-success";
                }
              } else {
                classBgPosition = "bg-danger";
              }

              return (
                <>
                  <div
                    key={index}
                    className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
                  >
                    <div className={classBgPosition}>
                      <div className="p-2 d-flex">
                        <div className="position-absolute">
                          <span>
                            {isPositionEmptyCampaignBanner === true ? (
                              generateCheckBoxAddPositionTag(
                                position,
                                isChecked,
                                addPositionToState
                              )
                            ) : (
                              <></>
                            )}
                            {/* {generateCheckBoxAddPositionTag(
                              position,
                              isChecked,
                              addPositionToState
                            )} */}
                          </span>
                        </div>
                        <div className="align-items-center justify-content-center d-flex flex-grow-1">
                          <span>اطلاعات جایگاه</span>
                          <span className="px-2">-</span>
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(position.id)}
                          </span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          اندازه
                        </div>
                        <div className="py-2 w-50 text-center">
                          <span
                            className="letter-spacing-finance-number"
                            dir="ltr"
                          >
                            {helpersNumbers.toPersianNum(
                              position.size.replace("-", "×")
                            )}
                          </span>
                          <span className="pr-2">پیکسل</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          ظرفیت کل
                        </div>
                        <div className="py-2 w-50 text-center">
                          {helpersNumbers.toPersianNum(position.count)}
                          <span className="pr-2">بنر</span>
                        </div>
                      </div>
                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          سهم شما
                        </div>
                        <div className="py-2 w-50 text-center">
                          {helpersNumbers.toPersianNum(1)}
                          <span className="pr-2">بنر</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          ارزش کل
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.base_price
                              )
                            )}
                          </span>
                          <span className="pr-2">تومان</span>
                        </div>
                      </div>

                      <div className=" d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          پرداختی شما
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                position.price
                              )
                            )}
                          </span>

                          <span className="pr-2">تومان</span>
                        </div>
                      </div>

                      <div className="px-2 d-flex border-top">
                        <div className="py-2 w-50 text-center border-left">
                          سهم نمایش
                        </div>
                        <div className="py-2 w-50 text-center ">
                          <span className="letter-spacing-finance-number">
                            {helpersNumbers.toPersianNum(
                              Math.floor((1 / position.count) * 100)
                            )}
                          </span>
                          <span className="pr-2">درصد</span>
                        </div>
                      </div>

                      <div dir="ltr" className="p-2 text-center border-top">
                        {position.tag_html_id}
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
        <div className="p-2">
          <span
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
            className="btn btn-success"
          >
            ذخیره و بازگشت
          </span>
        </div>
        <div className="p-2">
          <div>
            <a
              href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.img_name}`}
              target="_blank"
            >
              <img
                className="border border-success img-fluid"
                src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.img_name}`}
              />
            </a>
          </div>
        </div>
      </>
    );
  };

  const addPositionToState = (position) => {
    addPositionTagToState({
      site_publisher_url: sitePublisherData.url.replace("http://", ""),
      web_site_publisher_id: pageData.web_site_publisher_id,
      page_id: pageID,
      page_title: pageData.title,
      position_tag_html_id: position.tag_html_id,
      position_price: position.price,
      position_base_price: position.base_price,
      position_count: position.count,
      position_size: position.size,
    });

    if (typeAction === typeActionCategoryUserSitePublisher.EDIT) {
      addedPositionInEditAction({
        position: position.tag_html_id,
      });
    }
  };

  const checkDataExisiForcalculateAmountThisPage = () => {
    if (pageData === undefined) {
      return false;
    }

    if (sitePublisherData === undefined) {
      return false;
    }
    if (positions.length === 0) {
      return false;
    }

    if (dataSitePublisher[pageData.web_site_publisher_id] === undefined) {
      return false;
    }

    if (
      dataSitePublisher[pageData.web_site_publisher_id][pageID] === undefined
    ) {
      return false;
    }

    if (
      dataSitePublisher[pageData.web_site_publisher_id][pageID].positions
        .length === 0
    ) {
      return false;
    }
    return true;
  };

  const getPricePage = () => {
    if (!checkDataExisiForcalculateAmountThisPage()) {
      return 0;
    }
    return dataSitePublisher[pageData.web_site_publisher_id][pageID].price;
  };

  const generatePageDoseNotHaveAnyPositions = () => {
    return (
      <>
        <div className="text-left">
          <div
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
            className="btn btn-primary"
          >
            <span>بازگشت</span>
            <span className="pr-2">
              <i class="fas fa-arrow-left"></i>
            </span>
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-right">
            <img src="/assets/img/do-not-have-position.svg" />
          </div>
          <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p>این صفحه در حال حاضر هیچ جایگاهی ندارد.</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <TitleBar title={`جایگاه های تبلیغات ${pageData?.title} `} />

        <section className="content pt-5">
          <div className="card" id="select-position-container">
            <div className="card-body">
              {positions.length !== 0
                ? generatePositionsPageSitePublisher(positions)
                : generatePageDoseNotHaveAnyPositions()}
            </div>
          </div>
        </section>
      </div>
      <ExportFileExcelButton />
      <PreviewPositionsGroupSitePublisher />
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    addPositionTagToState: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.ADD_POSITION,
        payload: action,
      });
    },
    addPriceToPage: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.ADD_PRICE_TO_PAGE,
        payload: action,
      });
    },
    addedPositionInEditAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.POSITION_ADDED_IN_EDIT_ACTION,
        payload: action,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    typeAction: state.categoryUserSitePublisher.type_action,
    position_added_in_edit_action:
      state.categoryUserSitePublisher.position_added_in_edit_action,
    render: state.categoryUserSitePublisher.render,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllPositionsPageSitePublisher);
